// eslint-disable-next-line import/extensions
import ControlDataCardContainer from './ControlDataCardContainer.js';

export default ControlDataCardContainer;
